module.exports = "/static/js/6616950c937a4eac0b274fd6fb6ffc62.png";